import React, { memo } from "react";
import styles from "./VerificationSuccess.module.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const VerificationSuccess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const bookSlots = () => {
    navigate("/book-slot");
  };

  const onClose = () => {
  };

  return (
    <>
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <div className={styles.loginHeader}>
            <h2>Email Verification succcess</h2>
            <button className={styles.closeButton} onClick={onClose}>
              ✕
            </button>
          </div>
          <div className={styles.signUpFormFooter}>
            <button className={styles.submitButton} onClick={bookSlots}>
              Continue Booking
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

VerificationSuccess.whyDidYouRender = true;

export default memo(VerificationSuccess);
